





















import WField from "./WField.vue";
import { Component } from "vue-property-decorator";

@Component
export default class WFieldCheckbox extends WField {}
